import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Input from "../../widgets/Input";
import { useStores } from "../../models";

const StyledInput = styled(Input)`
  /* Add any additional input styling here */
`;

const VerificationCodeWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  position: relative;
`;

const CountdownButton = styled.button`
  position: absolute;
  right: 1px;
  top: 24px;
  outline: none;
  color: #1b9cea;
  border: none;
  border-radius: 6%;
  padding: 4px 12px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 12px;
  background-color: transparent;
  transition: opacity 0.3s;
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

const NormalInput = (props) => {
  return <StyledInput {...props} />;
};

const NormalInputCode = ({ value, name = '', countdownSeconds = 60, ...inputProps }) => {
  const { apiStore } = useStores();
  const [countdown, setCountdown] = useState(0);
  const timerRef = useRef(null);

  // Clean up timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  // Handle countdown logic
  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [countdown]);

  const handleGetCode = async () => {
    try {
      // Call the provided callback function
     const { code } = await apiStore.getPhoneSmsv1({
        type: 1,
        phone: name,
        country_code: '86'
      });
      console.log(code, 'code')
      // Start countdown only if callback succeeds
      setCountdown(countdownSeconds);
    } catch (error) {
      console.error("Failed to get verification code:", error);
    }
  };

  return (
    <VerificationCodeWrapper>
      <NormalInput
        {...inputProps}
        type="text"
        placeholder="请输入验证码"
        maxLength={6} // Typical verification code length
      />
      <CountdownButton
        onClick={handleGetCode}
        disabled={countdown > 0}
        type="button"
      >
        {countdown > 0 ? `${countdown}秒后重试` : "获取验证码"}
      </CountdownButton>
    </VerificationCodeWrapper>
  );
};

export default NormalInputCode;